/** CoStar.Api.MarketAnalytics.Dashboard.Model.LocationSearchStatus */
export var LocationSearchStatus;
(function (LocationSearchStatus) {
    LocationSearchStatus[LocationSearchStatus["Success"] = 0] = "Success";
    LocationSearchStatus[LocationSearchStatus["NoResults"] = 1] = "NoResults";
    LocationSearchStatus[LocationSearchStatus["NonForecasted"] = 2] = "NonForecasted";
})(LocationSearchStatus || (LocationSearchStatus = {}));
